/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-undefined */

// eslint-disable-next-line import/no-extraneous-dependencies
import {
  FcBriefcase,
  FcVoicePresentation,
  FcIdea,
  FcViewDetails,
  FcFaq,
  FcFinePrint,
  FcConferenceCall,
  FcUnlock,
} from 'react-icons/fc';
import {
  FiSearch,
  FiHeart,
  FiUpload,
  FiUser,
  FiDownload,
  FiMail,
  FiLogIn,
  FiLogOut,
  FiExternalLink,
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiEdit2,
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiChevronUp,
  FiClock,
  FiMenu,
  FiX,
  FiHome,
  FiUserCheck,
  FiUserX,
  FiMessageSquare,
  FiMessageCircle,
  FiChevronsRight,
  FiChevronsLeft,
  FiAward,
  FiTag,
  FiHelpCircle,
  FiFileText,
  FiArrowRight,
} from 'react-icons/fi';

// eslint-disable-next-line import/no-extraneous-dependencies
import type { FC, SVGAttributes } from 'react';
import type { IconType } from 'react-icons';

export interface IconProps {
  /**
   * Color of Icon.
   */
  color?: string;
  /**
   * Size of icon.
   */
  size?: number;
}

export interface ComponentProps extends IconProps, SVGAttributes<SVGAElement> {
  /**
   * The text that is not displayed but exists in DOM for accessibility purposes.
   */
}
type IconComponentProps = ComponentProps & { Component: IconType };

// This should be inlined in the createIcon function after the Icon component had been removed
const IconComponent: FC<IconComponentProps> = ({
  Component,
  role = 'img',
  'aria-hidden': ariaHidden,
  focusable = false,
  ...props
}) => {
  const hasLabelByAria =
    props['aria-label'] !== undefined || props['aria-labelledby'] !== undefined;
  // eslint-disable-next-line no-negated-condition
  const isAriaHidden = ariaHidden !== undefined ? ariaHidden : !hasLabelByAria;

  return (
    <>
      <Component
        role={role}
        aria-hidden={isAriaHidden !== undefined || undefined}
        focusable={focusable}
        {...props}
      />
    </>
  );
};

const createIcon = (SvgIcon: IconType) => {
  const Icon: FC<ComponentProps> = (props: ComponentProps) => (
    <IconComponent {...props} Component={SvgIcon} />
  );

  return Icon;
};

export const FiSearchIcon = createIcon(FiSearch);
export const FiHeartIcon = createIcon(FiHeart);
export const FiUploadIcon = createIcon(FiUpload);
export const FiUserIcon = createIcon(FiUser);
export const FiUserCheckIcon = createIcon(FiUserCheck);
export const FiUserXIcon = createIcon(FiUserX);
export const FiDownloadIcon = createIcon(FiDownload);
export const FiMailIcon = createIcon(FiMail);
export const FiLogInIcon = createIcon(FiLogIn);
export const FiLogOutIcon = createIcon(FiLogOut);
export const FiExternalLinkIcon = createIcon(FiExternalLink);
export const FiFacebookIcon = createIcon(FiFacebook);
export const FiTwitterIcon = createIcon(FiTwitter);
export const FiInstagramIcon = createIcon(FiInstagram);
export const FiEdit2Icon = createIcon(FiEdit2);
export const FiChevronDownIcon = createIcon(FiChevronDown);
export const FiChevronLeftIcon = createIcon(FiChevronLeft);
export const FiChevronRightIcon = createIcon(FiChevronRight);
export const FiChevronUpIcon = createIcon(FiChevronUp);
export const FiClockIcon = createIcon(FiClock);
export const FiMenuIcon = createIcon(FiMenu);
export const FiXIcon = createIcon(FiX);
export const FiHomeIcon = createIcon(FiHome);
export const FiMessageSquareIcon = createIcon(FiMessageSquare);
export const FiMessageCircleIcon = createIcon(FiMessageCircle);
export const FiChevronsRightIcon = createIcon(FiChevronsRight);
export const FiChevronsLeftIcon = createIcon(FiChevronsLeft);
export const FiAwardIcon = createIcon(FiAward);
export const FiTagIcon = createIcon(FiTag);
export const FiHelpCircleIcon = createIcon(FiHelpCircle);
export const FiFileTextIcon = createIcon(FiFileText);
export const FiArrowRightIcon = createIcon(FiArrowRight);

// Color icon
export const FcVoicePresentationIcon = createIcon(FcVoicePresentation);
export const FcBriefcaseIcon = createIcon(FcBriefcase);
export const FcViewDetailsIcon = createIcon(FcViewDetails);
export const FcIdeaIcon = createIcon(FcIdea);
export const FcFaqIcon = createIcon(FcFaq);
export const FcFinePrintIcon = createIcon(FcFinePrint);
export const FcUnlockIcon = createIcon(FcUnlock);
export const FcConferenceCallIcon = createIcon(FcConferenceCall);
